import React, { useState } from 'react';
import { Card, Image, Text, Group, Badge, TextInput, Flex, Modal, Button, ThemeIcon } from '@mantine/core';
import colors from '../utils/colors';
import { IconAt, IconAlertCircle } from '@tabler/icons-react';
import { showErrorNotification, showSuccessNotification } from './notifications';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { ctaPulse, fadeIn } from '../utils/animations';

export const InviteFriendCard: React.FC = () => {
  const [email, setEmail] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [emailError, setEmailError] = useState('');
  const { translate } = useLanguage();

  const validateEmail = () => {
    if (!email.includes('@')) {
      setEmailError(translate('invalidEmailFormat'));
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleOpenModal = () => {
    if (validateEmail()) {
      setModalOpen(true);
    }
  };

  const handleSend = async () => {
    const apiKey = localStorage.getItem('apiKey')

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_STUDIO_API_URL}/pwa/send-invitation-mail`,
        {
          reciever: email,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${apiKey}`,
          },
        }
      );
      showSuccessNotification(translate('invitationSent'));
      setEmail('');
      setModalOpen(false);
    } catch (error) {
      console.error('Błąd podczas wysyłania maila', error);
      showErrorNotification(translate('invitationError'));
      setModalOpen(false);
    }
  };


  return (
    <Card shadow="sm" padding="lg" radius="md" c={colors.custom36s} bg={`${colors.custom36p}50`}>
      <Card.Section>
        <Image
          src={'grafika36-1.png'}
          h={160}
          alt="36m"
        />
      </Card.Section>

      <Flex direction={'row'} justify="space-between" mt="md" mb="xs" pl={'xs'} pr={'xs'} align={'center'}>
        <Text fw={700} w={180} fz={'h4'}>{translate('inviteFriendTitle')} !</Text>
        <Badge variant="gradient"
         gradient={{ from: 'grape', to: 'violet', deg: 90 }}>
        {translate('friends')}</Badge>
      </Flex>

      <Text size="sm" c={colors.custom36s} fw={500} pl={'xs'} pr={'xs'} fz={'h5'}>
        {translate('inviteFriendDescription')}
      </Text>

      <TextInput
        type="email"
        leftSectionPointerEvents="none"
        leftSection={<IconAt size={16} />}
        placeholder={translate('enterFriendEmail')}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        mt={'xs'}
        mb={'xs'}
        m={'xs'}
        variant='filled'
        size='sm'
        radius={'lg'}
        error={emailError}
      />

      <motion.div 
        animate="animate" 
        variants={ctaPulse}
        className="text-center overflow-x-hidden"
      >
        <motion.button
          onClick={handleOpenModal}
          variants={fadeIn}
          whileTap={{ scale: 0.95 }}
          className="text-white bg-gradient-to-br from-custom36p via-custom36s/60 to-custom36s hover:bg-gradient-to-r focus:ring-4 focus:outline-none focus:ring-custom36p shadow-lg shadow-custom36p/50 font-medium rounded-lg border-none text-sm px-3 py-1.5 text-center tracking-wide mt-2"
        >
          <div className="flex items-center justify-center"> 
          {translate('sendInvite').toUpperCase()}
          </div>
        </motion.button>
      </motion.div>

      <Modal
        opened={modalOpen}
        onClose={() => setModalOpen(false)}
        title={<Text fw={500} size="md" c={colors.custom36s}>{translate('confirmTitle')}</Text>}
        centered
        withCloseButton
        styles={{
          content: {
            borderRadius: '12px',
          },
          header: {
            borderBottom: `1px solid ${colors.customGray}`,
            paddingBottom: '12px'
          },
          close: {
            color: colors.custom36s
          }
        }}
      >
        <Flex align="center" gap="md" className="mb-4 mt-2">
          <ThemeIcon color={colors.custom36p} size="md" radius="xl">
            <IconAlertCircle size={20} color={colors.white}/>
          </ThemeIcon>
          <Text size="sm" fw={500}>
            {translate('confirmSendInvitation', { email: email })}
          </Text>
        </Flex>
        <Flex gap="md" justify="flex-end">
          <Button variant="outline" color={colors.custom36s} onClick={() => setModalOpen(false)} size='xs'>
            {translate('cancel')}
          </Button>
          <Button 
            color={colors.custom36p}
            onClick={handleSend}
            size='xs'
          >
            {translate('confirm')}
          </Button>
        </Flex>
      </Modal>
    </Card>)
};
